











import { Component } from "vue-property-decorator";
import BasePage from "../base/BasePage";
import CaseDetail from "./Home/CaseDetail.vue";
import { Pages } from "@/enums/Pages";
import { BreadCrumb } from "@/store/modules/GlobalStore";
import { clientsStore } from "@/store/modules/ClientStore";
import { NullableString } from "@/code/Types";
import { Route } from "vue-router";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import { opportunitiyAttachmentStore } from "@/store/modules/OpportunityAttachmentStore";

@Component({
  components: {
    CaseDetail,
  },
})
export default class extends BasePage {
  page = Pages.CLIENT;
  title = "New Business Case Detail";
  breadCrumbs = [new BreadCrumb("New Business")];

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: () => void
  ): Promise<void> {
    await opportunityStore.select(to.params.id);
    opportunitiyAttachmentStore.parent = opportunityStore.current;
    await opportunitiyAttachmentStore.select(String(opportunityStore.current.opportunityId));
    await clientsStore.select(opportunityStore.current.clientId);
    next();
  }

  created(): void {
    this.title = `New Business Case Details: ${this.clientName}`;
    this.breadCrumbs.push(new BreadCrumb(String(this.clientName)));
  }

  get clientName(): NullableString {
    return `${clientsStore.current.clientFirstName} ${clientsStore.current.clientLastName}`;
  }
}
